import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="bg-surface border-t border-white/5 mt-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-1">
            <Link to="/" className="text-netflix-red font-bold text-xl tracking-tight no-underline">
              OPLIXI
            </Link>
            <p className="text-gray-500 text-xs mt-2 leading-relaxed max-w-[200px]">
              Your entertainment destination. Watch anywhere, anytime.
            </p>
          </div>

          {/* Browse */}
          <div>
            <h4 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Browse</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/movies" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Movies</Link>
              <Link to="/originals" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Originals</Link>
              <Link to="/categories" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Categories</Link>
              <Link to="/mylist" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">My List</Link>
            </nav>
          </div>

          {/* Account */}
          <div>
            <h4 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Account</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/profile" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Profile</Link>
            </nav>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Support</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/about" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">About</Link>
              <Link to="/help" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Help Center</Link>
              <Link to="/faq" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">FAQ</Link>
              <Link to="/contact" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Contact</Link>
              <Link to="/about#attributions" className="text-gray-500 hover:text-white text-sm no-underline transition-colors">Attributions</Link>
            </nav>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/5 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} Oplixi. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-gray-600 hover:text-gray-400 text-xs no-underline transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-600 hover:text-gray-400 text-xs no-underline transition-colors">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
